import { useSnackbar } from 'notistack';
import { loadingActions } from 'features';
import { movementReasonService, supplierService } from 'services/api';
import { useAppDispatch } from 'app/store';
import TenantPage from 'components/common/TenantPage';
import { useTranslation } from 'react-i18next';
import MovementReasonsForm from '../MovementReasonsForm';
import { IMovementReason } from 'interfaces';

const initMovementReason: IMovementReason = {
  id: null,
  code: null,
  direction: 'IN',
  description: null,
  discounted: false,
  order_independent: false
};

export const AddMovementReason = () => {
  const translationPrefix = 'movement-reasons.pages.new';
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const createMovementReason = async (values) => {
    dispatch(loadingActions.startLoading());
    movementReasonService.add(values).then((res) => {
      enqueueSnackbar('Causale aggiunta con successo');
    });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <MovementReasonsForm movementReason={initMovementReason} onSubmit={createMovementReason} />
    </TenantPage>
  );
};

export default AddMovementReason;
